import React from 'react'
import { Link } from 'react-router-dom'

const Page404 = () => {
    return (
        <div>
            <main className="main page-404">
                <div className="page-content pt-150 pb-150">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-8 col-lg-10 col-md-12 m-auto text-center">
                                <p className="mb-20"><img src="assets/imgs/page/page-404.png" alt className="hover-up" /></p>
                                {/* <p className='mb-20' style={{ fontSize: "150px", color: "#9E423E" }}>
                                    4
                                    <img src='assets/imgs/logo/6.png' className="hover-up" width="130" height="130" />
                                    4
                                </p> */}
                                <h1 className="display-2 mb-30">Page Not Found</h1>
                                <p className="font-lg text-grey-700 mb-30">
                                    The link you clicked may be broken or the page may have been removed.<br />
                                    visit the <a href="index.html"> <span> Homepage</span></a> or <a href="page-contact.html"><span>Contact us</span></a> about the problem
                                </p>
                                <Link className="btn btn-default submit-auto-width font-xs hover-up mt-30" to={'/'}><i className="fi-rs-home mr-5" /> Back To Home Page</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

        </div>
    )
}

export default Page404